import Styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

interface Props {
  width: string;
  color: string;
}

export const Container = Styled.div<Props>`
  width: 100%;

  progress {
    margin-right: 8px;
  }
  
  progress[value] {
    width: ${props => props.width};
    
    -webkit-appearance: none;
    appearance: none;
  }
  
  progress[value]::-webkit-progress-bar {
    height: ${themeGet('space.2')};
    border-radius: ${themeGet('space.5')};
    background-color: ${themeGet('colors.background.primary')};
    border: 1px solid ${themeGet('colors.glassDark.8')};
    border-radius: 24px;
  }  

  progress[value]::-webkit-progress-value {
    border-radius: 24px;
    background-color: ${props => themeGet(props.color)};
    transition: width 0.3s ease; 
  }
`;

export const StepsContainer = Styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  margin-top: ${themeGet('space.4')}px;
`;

interface ProgressLabelProps {
  completed?: boolean;
  active?: boolean;
}

export const PillContainer = Styled.div<ProgressLabelProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 32px;
  font-size: ${themeGet('fontSizes.0')}px;
  font-weight: ${props => (props.active ? 'bold' : 'normal')};
  background-color: ${props => (props.completed ? themeGet('colors.success.background') : themeGet('glassDark.1'))};
  color: ${props => (props.completed ? themeGet('colors.success.text') : themeGet('border.primary'))};

  border: 1px solid ${props => (props.completed ? themeGet('colors.success.border') : themeGet('border.primary'))};
  border-width: ${props => (props.active ? '2px' : '1px')};
`;

export const ProgressText = Styled.div<ProgressLabelProps>`
  font-size: ${themeGet('fontSizes.2')}px;
  color: ${themeGet('text.primary')};
  margin-left: ${themeGet('space.2')}px;
  font-weight: ${props => (props.active ? 'bold' : 'normal')};

  @media (max-width: 768px) {
    display: none; 
  }
`;
